/* globals MobileDetect */

/* exported AppStoreLinks */

'use strict';

var AppStoreLinks = (function() {

    var links = window.$App.appStoreLinks;

    if (!links) {
        return;
    }

    var redirectToAppStore = function() {
        var md = new MobileDetect(window.navigator.userAgent);
        var os = md.os();

        if (os === 'iOS' && links.ios) {
            window.location.replace(links.ios);
            return;
        }
        if (os === 'AndroidOS' && links.android) {
            window.location.replace(links.android);
            return;
        }
        if (links.fallback) {
            window.location.replace(links.fallback);
            return;
        }
    };

    return {
        redirect: redirectToAppStore
    };
})();


$(function() {
    AppStoreLinks.redirect();
});
